// Warm only a few navigation destinations after deliberate hover or keyboard focus.
// Native navigation, history, analytics and forms remain unchanged.
if (!window.Shopify?.designMode && !navigator.connection?.saveData && !/2g/.test(navigator.connection?.effectiveType || '')) {
  const warmed = new Set();
  const root = window.Shopify?.routes?.root || '/';
  let timer;
  const warm = (anchor) => {
    if (!anchor || anchor.target || anchor.hasAttribute('download') || warmed.size >= 4) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || url.search || url.hash || url.pathname === location.pathname) return;
    if (!url.pathname.startsWith(root)) return;
    const path = url.pathname.slice(root.length);
    if (path !== '' && !/^(pages|collections)(\/|$)/.test(path)) return;
    if (warmed.has(url.href)) return;
    warmed.add(url.href);
    const link = document.createElement('link');
    link.rel = 'prefetch'; link.as = 'document'; link.href = url.href;
    document.head.append(link);
  };
  document.addEventListener('pointerover', (event) => {
    const anchor = event.target.closest('header a[href], nav a[href], header-component a[href]');
    clearTimeout(timer);
    if (anchor) timer = setTimeout(() => warm(anchor), 100);
  }, { passive: true });
  document.addEventListener('pointerout', () => clearTimeout(timer), { passive: true });
  document.addEventListener('focusin', (event) => warm(event.target.closest('header a[href], nav a[href], header-component a[href]')));
}
